module.exports = __webpack_public_path__ + "img/xlm.d3a5ffff.svg";